import { frameIndexInSecond } from '../frame/frameMath';
import type { FrameRate } from '../frame/frameRates';

export interface StripView {
  update(nowMs: number, rate: FrameRate): void;
}

export function createStripView(host: HTMLElement): StripView {
  host.classList.add('strip');
  let currentRateId: string | null = null;
  let boxes: HTMLElement[] = [];
  let litIndex = -1;

  function rebuild(rate: FrameRate): void {
    const count = Math.ceil(rate.fps);
    host.style.gridTemplateColumns = `repeat(${count}, 1fr)`;
    host.innerHTML = '';
    boxes = [];
    for (let i = 0; i < count; i++) {
      const el = document.createElement('div');
      el.className = 'strip__box';
      el.textContent = i.toString().padStart(2, '0');
      host.appendChild(el);
      boxes.push(el);
    }
    currentRateId = rate.id;
    litIndex = -1;
  }

  return {
    update(nowMs, rate) {
      if (rate.id !== currentRateId) rebuild(rate);
      const idx = frameIndexInSecond(nowMs, rate);
      if (idx !== litIndex) {
        if (litIndex >= 0) boxes[litIndex]?.classList.remove('is-lit');
        boxes[idx]?.classList.add('is-lit');
        litIndex = idx;
      }
    },
  };
}
